export default function (value: undefined | null | number): number {
  if (!value) return 0;
  return value;
}
